module.exports = __webpack_public_path__ + "media/images/sp/page_common/banner/banner_fair-12063776b62dba26ff24c994cfda02b0.jpg";